export const FALLBACK_TIMEZONE = 'Eastern Standard Time';

export const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
